import { Alert, AlertTitle, Button } from "@mui/material";
import { useAppContext } from "context";
import dayjs from "dayjs";
import { formatDate } from "hooks";
import { Dialog } from "layout";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AddEditFiscalYear from "./FiscalYearForm/AddEditFiscalYear";

const FyAlert = () => {
  const { t } = useTranslation(['common', 'forms', 'tables', 'alerts']);
  const navigate = useNavigate();
  const { settings } = useAppContext();
  const [showForm, setShowForm] = useState(false);

  const isTodayOrPast = settings?.fyEndDate
    ? dayjs(settings?.fyEndDate).startOf("day").valueOf() <=
      dayjs().startOf("day").valueOf()
    : false;

  const handleForwardToFiscal = () => {
    navigate(`/fiscal_year/fy_snapshots/${settings?.fiscalYearId}`);
  };

  const handleOpenFy = () => {
    setShowForm(!showForm);
  };

  const handleLockFiscal = () => {
    navigate(`/fiscal_year/fy_snapshots/${settings?.lastUnlockFyId}`);
  };

  return (
    <>
      {isTodayOrPast && (
        <div className="mb-[15px]">
          <Alert severity="warning">
            <AlertTitle>{t('alerts:pleaseCloseFiscalYear')}</AlertTitle>
            <p>
              {t('alerts:fyClosingMessage', { startDate: formatDate(settings?.fyStartDate, "DD MMMM, YYYY"), endDate: formatDate(settings?.fyEndDate, "DD MMMM, YYYY") })}
            </p>

            {!window.location.pathname.includes(
              "/fiscal_year/fy_snapshots/"
            ) && (
              <Button
                onClick={handleForwardToFiscal}
                color="inherit"
                size="small"
                className="!min-w-[180px] !font-bold !mt-[15px]"
              >
                {t('alerts:closeNow')}
              </Button>
            )}
          </Alert>
        </div>
      )}

      {settings.decimal && !settings?.fiscalYearId && (
        <div className="mb-[15px]">
          <Alert severity="error">
            <AlertTitle>{t('alerts:fySetupNeeded')}</AlertTitle>
            <p>
              {t('alerts:fySetupMessage')}
            </p>

            <Button
              onClick={handleOpenFy}
              color="inherit"
              size="small"
              className="!min-w-[120px] !font-bold !mt-[15px]"
            >
              {t('alerts:openNow')}
            </Button>
          </Alert>
        </div>
      )}

      {settings?.lastUnlockFyId && (
        <div className="mb-[15px]">
          <Alert severity="info">
            <AlertTitle>{t('alerts:lockAndFinalizeFy')}</AlertTitle>
            <p>
              {t('alerts:lockFyMessage')}
            </p>

            {!window.location.pathname.includes(
              "/fiscal_year/fy_snapshots/"
            ) && (
              <Button
                onClick={handleLockFiscal}
                color="inherit"
                size="small"
                className="!min-w-[120px] !font-bold !mt-[15px]"
              >
                {t('alerts:lockNow')}
              </Button>
            )}
          </Alert>
        </div>
      )}

      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="xs">
          <AddEditFiscalYear {...{ setShowForm, reloadSystem: true }} />
        </Dialog>
      )}
    </>
  );
};

export default FyAlert;
